module.exports = __webpack_public_path__ + "assets/img/c218c80e01ead89435bed317ff2283a5.png";